import baseCreate from './_baseCreate.js';
import isObject from './isObject.js';

// Internal function to execute `sourceFunc` bound to `context` with optional
// `args`. Determines whether to execute a function as a constructor or as a
// normal function.
export default function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
  if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
  var self = baseCreate(sourceFunc.prototype);
  var result = sourceFunc.apply(self, args);
  if (isObject(result)) return result;
  return self;
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_executeBound.js
// module id = 633
// module chunks = 0